export { default } from './ListTwoTicketDetails';
